import * as Yup from "yup";
import { createValidationRule } from "../../../commonComponent/validation/validation";

export const phoneValidationSchema = Yup.object({
  phoneNumber: createValidationRule("phone"),
});

export const otpValidationSchema = Yup.object({
  otp: createValidationRule("otp"),
});

export const passwordValidationSchema = Yup.object({
  password: createValidationRule("password"),
  confirmPassword: createValidationRule("confirmPassword"),
});

export const changePasswordValidationSchema = Yup.object({
  oldPassword: createValidationRule("password"),
  password: createValidationRule("password").required("New password is required"),
  confirmPassword: createValidationRule("confirmPassword"),
});

export const registractionValidation = Yup.object({
  email: createValidationRule("email"),
  password: createValidationRule("password"),
  confirmPassword: createValidationRule("confirmPassword"),
  // role: Yup.string().required("Role is required"),
  firstName: createValidationRule("string"),
  lastName: createValidationRule("string"),
  clinicName: Yup.string().required("Clinic name is required"),
  // phoneNumber: createValidationRule("phone"),
  experience: createValidationRule("number"),
  speciality: Yup.string().required("Specialty is required"),
  qualification: Yup.string().required("Qualification is required"),
  consultationFee: createValidationRule("number"),
  // working_days: Yup.array().min(1, "At least one working day is required"),
  // working_hours: Yup.object({
  //   start: Yup.string().required("Start time is required"),
  //   end: Yup.string().required("End time is required"),
  // }),
});

export const registractionValidationReceptionist = Yup.object({
  email: createValidationRule("email"),
  password: createValidationRule("password"),
  confirmPassword: createValidationRule("confirmPassword"),
  // role: Yup.string().required("Role is required"),
  firstName: createValidationRule("string"),
  lastName: createValidationRule("string"),
  clinicName: Yup.string().required("Clinic name is required"),
});
